import { Component, OnInit, ViewChild, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { CkEditorComponent } from '../../../shared/ck-editor/ck-editor.component';
import { SortByPipe } from '../../../shared/pipes/sort-by.pipe';
import { Observable } from 'rxjs';
import { PassageModel } from '@generativ/much-smarter-models';
import { PassageService } from '../passage.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ...MATERIAL_IMPORTS, SpinnerComponent, CkEditorComponent],
  selector: 'app-passage-list',
  templateUrl: './passage-list.component.html',
  styleUrls: ['./passage-list.component.scss'],
  providers: [SortByPipe],
})
export class PassageListComponent implements OnInit {

  passages: Observable<PassageModel[]>;
  readonly paginatedPassages = signal<PassageModel[]>([]);

  @ViewChild(MatPaginator) paginator: MatPaginator;
    length = 100;
    pageSize = 10;
    pageIndex = 0;
    pageSizeOptions = [5, 10, 25, 100];

  constructor(
    private passageService: PassageService,
    private sortBy: SortByPipe
  ) { }

  ngOnInit() {
    this.passages = this.passageService.getPassages();
    this.passages.subscribe((data) => {
      data = this.sortBy.transform(data, 'title');

      this.length = data.length;
      this.paginatedPassages.set(data.slice(0, this.pageSize));
    })
  }

  public getPassagesPagination(event?: PageEvent) {

    this.passages.subscribe(data => {
      data = this.sortBy.transform(data, 'title');

      // Since we're getting a sub-set of of this observable list, it's important to apply the pipe here and get the sub-array for the pagination already sorted
      this.paginatedPassages.set(data.slice(this.paginator.pageIndex * this.paginator.pageSize, this.paginator.pageIndex * this.paginator.pageSize + this.paginator.pageSize));
    });

    return event;
  }

}
